<header class="cn-nav" [class.cn-nav--scrolled]="scrolled()">
  <nav class="cn-nav__inner cn-container cn-container--wide">
    <a href="#top" aria-label="ChircalNet — inicio" style="display:flex">
      <img
        [src]="isDark() ? 'logo-full-white.png' : 'logo-full-color.png'"
        alt="ChircalNet Telecom"
        style="height:30px;width:auto;display:block"
      />
    </a>

    <div class="cn-nav__links">
      @for (link of links(); track link.href) {
        <a class="cn-nav__link" [href]="link.href">{{ link.label }}</a>
      }
    </div>

    <div class="cn-nav__actions">
      <button class="cn-iconbtn cn-iconbtn--md" aria-label="Cambiar tema" (click)="toggleDark.emit()">
        @if (isDark()) {
          <lucide-icon name="sun" [size]="20" />
        } @else {
          <lucide-icon name="moon" [size]="20" />
        }
      </button>
      <a
        class="cn-btn cn-btn--ghost cn-btn--sm cn-nav__hide-sm"
        [href]="portalUrl()"
        target="_blank"
        rel="noopener noreferrer"
      >Acceder</a>
      <a class="cn-btn cn-btn--accent cn-btn--sm" href="#planes">Contratar</a>
      <button
        class="cn-iconbtn cn-iconbtn--md cn-iconbtn--outline cn-nav__burger"
        aria-label="Abrir menú"
        (click)="openMenu.emit()"
      >
        <lucide-icon name="menu" [size]="22" />
      </button>
    </div>
  </nav>
</header>
